const getCursorPosition = (event, element) => {
  const elementBounds = element.getBoundingClientRect();
  const { left: elementLeftBound, top: elementTopBound } = elementBounds;
  const { pageX, pageY } = event;
  const cursorPosition = {
    x: pageX - elementLeftBound - window.pageXOffset,
    y: pageY - elementTopBound - window.pageYOffset
  };
  return cursorPosition;
};
const defaultLensConfig = {
  zoom: 2,
  width: 200,
  height: 200
};

export { defaultLensConfig, getCursorPosition };
//# sourceMappingURL=bundle.esm3.js.map
